export const ACTION_TYPES = {
    FETCH_START: "FETCH_START",
    FETCH_SUCCESS: "FETCH_SUCCESS",
    FETCH_ERROR: "FETCH_ERROR",
    CHANGE_INPUT: "CHANGE_INPUT",
    CHANGE_DATE: "CHANGE_DATE"
  };